import {createAction} from '@reduxjs/toolkit'
import {
  ClassificationTypes,
  GetAnalyticsDetailFilter as SetResourceTypeFilter,
  POLICY_TYPE,
} from 'interfaces'
export const setAnalyticsDetailFilters = createAction<SetResourceTypeFilter>(
  'setAnalyticsDetailFilters',
)
export const setSortAscending = createAction<boolean>('setSortAscending')
export const resetAnalyticsDetailState = createAction(
  'resetAnalyticsDetailState',
)

export const setAnalyticsDetailScope = createAction<SetResourceTypeFilter>(
  'analyticsDetail/setScope',
)
export const setAnalyticsDetailCategory = createAction<{
  category: string
  policyType: POLICY_TYPE
}>('analyticsDetail/setCategory')
export const setAnalyticsDetailPolicyTypes = createAction<POLICY_TYPE[]>(
  'analyticsDetail/setPolicyTypes',
)
export const setAnalyticsDetailClassifications = createAction<
  ClassificationTypes[]
>('analyticsDetail/setClassifications')
